import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';

type ListIconProps = {
  text: string;
  icon?: JSX.Element;
  link: string;
  isActive?: boolean;
};
const ListIcon: FC<ListIconProps> = ({
  text,
  icon,

  link,
  isActive,
}) => {
  return (
    <React.Fragment>
      <NavLink to={link}>
        <div
          className={`flex items-center rounded-[3px] gap-[6px] hover:bg-neutral-200 mx-[10px] p-[8px] cursor-pointer group  ${
            isActive
              ? 'border-l-[3px] border-blue-voilet bg-blue-voilet/15 shadow-[0_1.5px_4px_-1px_rgba(10, 9, 11, 0.07)]'
              : ''
          }`}
        >
          {icon}
          <p
            className={`text-[14px] font-[475] leading-5 tracking-tighter-[-0.05px] group-hover:text-blue-voilet ${
              isActive ? 'text-black' : 'text-neutral-1000'
            }`}
          >
            {text}
          </p>
        </div>
      </NavLink>
    </React.Fragment>
  );
};

export default ListIcon;
